/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ query: NonNullable<unknown> }} Directory_Search_AnythingInputs */

const en_directory_search_anything = /** @type {(inputs: Directory_Search_AnythingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Search for “${i?.query}”`)
};

const pl_directory_search_anything = /** @type {(inputs: Directory_Search_AnythingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Szukaj „${i?.query}”`)
};

/**
* | output |
* | --- |
* | "Search for “{query}”" |
*
* @param {Directory_Search_AnythingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_search_anything = /** @type {((inputs: Directory_Search_AnythingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_AnythingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_search_anything(inputs)
	return en_directory_search_anything(inputs)
});